export enum StateBill {
	PENDIENTE = 'Pendiente',
	PAGADO = 'Pagado',
	CANCELADA = 'Cancelada',
}
export enum StateBillE {
	PENDIENTE = 'Pendiente',
	PAGADO = 'Pagado',
	CANCELADA = 'Cancelada',
}
